import { CostCodeModel } from '../../backend/time/model/cost-code.model';

export interface CostCodeStateInterface {
  costCodes: CostCodeModel[];
}

export const initCostCodeState: CostCodeStateInterface = {
  costCodes: [],
};
